import {
  GcIconColor,
  gcIconNames,
  gcTextColors,
} from '@ip-only/front-end-library';
import { StatusStyle } from './status-style.entities';

export function createBasicStatusStyle(iconColor: GcIconColor): StatusStyle {
  return {
    icon: { name: gcIconNames.circleFilled, color: iconColor },
    textColor: gcTextColors.primary,
  };
}
